import { render } from "./NewMessageForm.vue?vue&type=template&id=270b5042&scoped=true"
import script from "./NewMessageForm.vue?vue&type=script&lang=js"
export * from "./NewMessageForm.vue?vue&type=script&lang=js"

import "./NewMessageForm.vue?vue&type=style&index=0&id=270b5042&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270b5042"]])

export default __exports__